import api from 'apis/config/api-service';

interface InvitationRequest {
  id: string | number;
  [key: string]: any;
}

interface InvitationParams {
  [key: string]: any;
}

interface MergeData {
  [key: string]: any;
}

export default {
  getInvitationRequests: (params?: InvitationParams) => api.get('invitation-request', { ...params }),
  getInvitationById: (id: string | number) => api.get(`invitation-request/${id}`),
  updateInvitation: (invitation: InvitationRequest) => api.patch(`invitation-request/${invitation.id}`, invitation),
  saveAndNotify: (invitation: InvitationRequest) => api.post('invitation-request/save-and-notify', invitation),
  mergeSupplier: (data: MergeData) => api.post('invitation-request/merge-supplier', data),
};
